import { Component } from 'react'
import Select from 'react-select'
import Typeahead from '../helpers/Typeahead'
import { FormattedMessage } from 'react-intl'
import FilterList from '../search/FilterList'
import { autosuggestStyles } from '../search/FiltersLa'
// import TravelDatepicker from '../helpers/TravelDatepicker'

const expandedFilters = {
  trip_type: true,
  trip_language: true,
}
export default class FiltersGroup extends Component {
  constructor(props) {
    super(props)

    this.state = {
      title: '',
      filtersToggler: {
        price: true,
        duration: true,
        diving_intensity: true,
        experience: true,
      },
      monthes: props.monthes,
    }
  }

  updateMonth(selectedOption) {
    if(!selectedOption) {
      this.props.clearDates()
    } else {
      this.props.updateParams({
        'departure_date_month': selectedOption,
        'departure_date': selectedOption.from,
      })
    }
  }

  render() {
    return (
      <div className='filters'>
        <div className='main-filters' id='la-main-filters'>
          <p className='title'><FormattedMessage id='search' defaultMessage='Search' /></p>
          <div className='search-block'>
            <label className='w_icon'>
              <i className='font-icons field-icon location-icon' />
              <Typeahead isWidget={this.props.isWidget} type='group' inputValue={this.props.title} popupId='country-list-popup' />
            </label>
          </div>
          <div className={`form-group w_icon ${!this.props.selectedFilters.departure_date_month ? 'has-error' : ''}`}>
            <i className='font-icons field-icon calendar-icon' />
            <Select
              onChange={(selectedOption) => this.updateMonth(selectedOption)}
              value={this.props.selectedFilters.departure_date_month}
              options={this.state.monthes}
              styles={autosuggestStyles}
              isSearchable={false}
              valueKey='id'
              isClearable
              className='select-container'
              classNamePrefix='select-container' />
          </div>
          <button className='btn-red' id='search-btn' onClick={this.props.triggerApi}>
            <i className='font-icons find-icon' />
            <FormattedMessage id='search' defaultMessage='Search' />
          </button>
        </div>
        <FilterList
          expandedFilters={expandedFilters}
          updateParams={this.props.updateParams}
          selectedFilters={this.props.selectedFilters}
          items={this.props.items}
          showTripOrganiser
          clearSelectedFilters={this.props.clearSelectedFilters}
          filtersCount={this.props.filtersCount}
          model={this.props.model}
          pk={this.props.pk}
          groupTrips={this.props.groupTrips}
        />
        <div className='shadow-block'>
          <p className='title text-center'><FormattedMessage id='padi_traveler_reviews' defaultMessage='PADI travel reviews' /></p>
          <div className='trust-pilot text-center'>
            <div
              className='trustpilot-widget'
              data-locale={this.props.trustpilotLocale}
              data-template-id='53aa8912dec7e10d38f59f36'
              data-businessunit-id='55eeddbb0000ff00058313b3'
              data-style-height='130px' data-style-width='100%'
              data-theme='light'
              data-stars='5'
              data-schema-type='Organization'>
              <a href='https://www.trustpilot.com/review/travel.padi.com' target='_blank'>Trustpilot</a></div>
          </div>
        </div>
      </div>
    )
  }
}

// export default connect(
//   state => ({
//       pageLoader: state.pageLoader,
//   })
// )(FiltersGroup)
